import React, { useState, useEffect } from "react";
import pdfIcon from "@/assets/icons/icon-pdf.svg";
import { useUploadFileMutation } from "@/redux/uploadApi";
import { Loading, Toast, Confirm } from "@/components";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

export const ImageUpload = ({
    maxImages,
    labelText,
    inputIdPrefix,
    placeholderText,
    onUploadComplete, // 업로드 완료 시 호출될 콜백
    onRemoveImage, // 이미지 삭제 시 호출될 콜백
    onReorderImages, // 드래그&드랍 순서 변경 시 호출될 콜백
    uploadType, // 업로드 타입
    contractIndex, // 계약서 인덱스
    contractId, // 계약 ID
    initialImages = [], // 상세 조회 시 초기 이미지 데이터
    imageType, // 이미지 타입 (예: "RENT_CAR")
    readOnly, // readOnly
}) => {
    const [uploadFile, { isLoading: isPostLoading }] = useUploadFileMutation();
    const [images, setImages] = useState([]);

    // 최초 마운트 시에만 initialImages로 초기화
    useEffect(() => {
        console.log(initialImages);
        if (images.length === 0 && initialImages && initialImages.length > 0) {
            const initialImageState = initialImages
                .map((img, index) => ({
                    id: `${inputIdPrefix}_${index + 1}`,
                    file: img.upload.objectUrl || img.upload.url,
                    fileType: img.upload.fileExtName,
                    uploadId: img.upload.id,
                }))
                .map((img) => ({ ...img }));
            setImages(initialImageState);
        }
        // eslint-disable-next-line
    }, [initialImages]);

    const handleImageChange = async (event, index) => {
        const files = event.target.files;
        if (!files || files.length === 0) return;

        const fileArray = Array.from(files);
        const startIndex = index === -1 ? images.length : index;

        // 기존 배열을 deep copy
        const updatedImages = images.map((img) => ({ ...img }));

        for (const file of fileArray) {
            const currentIndex = startIndex + fileArray.indexOf(file);
            if (currentIndex >= maxImages) break;

            try {
                const formDataObj = new FormData();
                formDataObj.append("file", file);
                const res = await uploadFile(formDataObj).unwrap();
                const uploadId = res.data?.id || 0;

                const newImage = {
                    id: `${inputIdPrefix}_${currentIndex + 1}`,
                    file: URL.createObjectURL(file),
                    fileType: file.type,
                    uploadId,
                };

                if (currentIndex >= updatedImages.length) {
                    updatedImages.push(newImage);
                } else {
                    updatedImages[currentIndex] = newImage;
                }

                if (onUploadComplete) {
                    console.log(contractIndex);
                    // contractIndex가 undefined나 null이 아닌 경우 onUploadComplete
                    if (contractIndex !== undefined && contractIndex !== null) {
                        console.log("A");
                        onUploadComplete({
                            uploadId,
                            uploadType,
                            contractId,
                            index: currentIndex,
                            contractIndex,
                            imageType,
                        });
                    } else {
                        console.log("B");
                        onUploadComplete({
                            uploadId,
                            uploadType,
                            contractId,
                            index: currentIndex,
                            imageType,
                        });
                    }
                }
            } catch (error) {
                console.error("파일 업로드 실패:", error);
                continue;
            }
        }

        setImages([...updatedImages]);
    };

    const handleImageClick = (index) => {
        document.getElementById(`${inputIdPrefix}-${index}`).click();
    };

    const handleRemoveImage = (event, index) => {
        event.stopPropagation();
        // deep copy 후 splice
        const updatedImages = images.map((img) => ({ ...img }));
        updatedImages.splice(index, 1);
        setImages([...updatedImages]);
        if (onRemoveImage) {
            // contractIndex가 undefined나 null이 아닌 경우
            if (contractIndex !== undefined && contractIndex !== null) {
                onRemoveImage(index);
            } else {
                onRemoveImage(contractId, index);
            }
        }
    };

    // 드래그&드랍 정렬 핸들러
    const onDragEnd = (result) => {
        if (!result.destination) return;
        const reordered = Array.from(images);
        const [removed] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, removed);
        setImages(reordered);
        if (onReorderImages) {
            // initialImages의 순서를 images의 id/uploadId 순서에 맞게 재정렬
            const reorderedOriginObjects = reordered.map(
                (img) =>
                    initialImages.find((origin) => {
                        // id가 숫자인 경우와 문자열인 경우 모두 대응, uploadId도 비교
                        return (
                            (origin.id && img.id && String(origin.id) === String(img.id)) ||
                            (origin.upload && img.uploadId && origin.upload.id === img.uploadId)
                        );
                    }) || {}
            );
            // contractIndex가 undefined나 null이 아닌 경우
            if (contractIndex !== undefined && contractIndex !== null) {
                onReorderImages(reorderedOriginObjects);
            } else {
                onReorderImages(contractId, reorderedOriginObjects);
            }
        }
    };

    return (
        <>
            <div className="image-container">
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="image-list" direction="horizontal">
                        {(provided) => (
                            <div className="image-list" ref={provided.innerRef} {...provided.droppableProps}>
                                {images.map((image, index) => (
                                    <Draggable key={image.id} draggableId={image.id} index={index}>
                                        {(provided) => (
                                            <div
                                                className="item"
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <div className="item-img">
                                                    {image.fileType === "application/pdf" ? (
                                                        <div className="img-preview">
                                                            <button
                                                                type="button"
                                                                className="btn-remove_img"
                                                                onClick={(e) => handleRemoveImage(e, index)}
                                                            ></button>
                                                            <div className="pdf-preview">
                                                                <img src={pdfIcon} alt="" /> PDF 파일
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="img-preview">
                                                            {
                                                                !readOnly && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn-remove_img"
                                                                        onClick={(e) => handleRemoveImage(e, index)}
                                                                    ></button>
                                                                )
                                                            }
                                                            <img src={image.file} alt={`Uploaded ${index + 1}`} onClick={(e) => {
                                                                window.open(image.file, '_blank');
                                                            }} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                                {/* add_file은 드래그 대상이 아님 */}
                                {(images.length < maxImages && !readOnly) && (
                                    <div className="item add_file">
                                        <div className="item-img" onClick={() => handleImageClick(-1)}>
                                            <div className="img-input">
                                                <input
                                                    type="file"
                                                    onChange={(e) => handleImageChange(e, -1)}
                                                    id={`${inputIdPrefix}--1`}
                                                    style={{ display: "none" }}
                                                    multiple={maxImages > 1}
                                                />
                                                <label htmlFor={`${inputIdPrefix}--1`}></label>
                                            </div>
                                            <div className="img-txt">{placeholderText}</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
        </>
    );
};
